import type { EvidenceItem } from '../types/investigator';

/** Maps API icon codes to short category headings (sync with zeecore labels.ts). */
const ICON_CATEGORY_LABEL: Record<string, string> = {
  order_event: 'Order',
  vehicle_movement: 'Vehicle activity',
  driver_shift: 'Driver hours',
  fuel_event: 'Fuel',
  anomaly: 'Operational alert',
};

function humanizeInternalViewName(view: string): string {
  return view
    .replace(/View$/, '')
    .replace(/Capability$/, '')
    .replace(/([A-Z])/g, ' $1')
    .trim();
}

/** User-facing source label; hides internal "truth-layer" placeholder. */
export function getEvidenceSourceLabel(source?: string): string | undefined {
  if (!source || source === 'truth-layer') return undefined;
  return source;
}

/** Category heading for Timeline / Evidence cards. */
export function getEvidenceCategoryLabel(item: EvidenceItem): string {
  if (item.evidence_category) return item.evidence_category;
  if (ICON_CATEGORY_LABEL[item.evidence_type]) {
    return ICON_CATEGORY_LABEL[item.evidence_type];
  }
  if (/View$|Capability$/.test(item.evidence_type)) {
    return humanizeInternalViewName(item.evidence_type);
  }
  return item.evidence_type.replace(/_/g, ' ');
}
